import {Task} from "../../task/models/Task";
import {ClassicType} from "../../shared/models/ClassicType";

export class Ticket extends Task{
  chiuso?: boolean;
  stato: number;
  notaInterna: string;
  notaChiusura: string;
  statoObject: ClassicType;
  tipoObject: ClassicType;
  constructor() {
    super();
    this.chiuso = false;
  }
}
